module.exports = __webpack_public_path__ + "img/endoscopia.fa85cecd.png";